import React from "react";
import clsx from 'clsx';
import { SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const blockStyles = makeStyles(theme => ({
  root: {
    width: 24,
    height: 24,
    fill: "transparent"
  }
}));

const IcGrayBadge = (props) => {

  const classes = blockStyles();
  const { className } = props;

  return (
    <SvgIcon className = { clsx(classes.root, className) }
             viewBox = { "0 0 24 24" } >
      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z" fill="#D5D5D5"/>
      <path d="M9.44912 15.4207L6.13019 12.1018L5 13.224L9.44912 17.6731L19 8.12223L17.8778 7L9.44912 15.4207Z" fill="white"/>
    </SvgIcon>
  );
}

export default IcGrayBadge;

